var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('i',{staticClass:"loader",staticStyle:{"width":"16px","height":"16px","background-size":"16px"}}),_vm._v(" "+_vm._s(_vm.msg)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }